import { Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const JobAnalyticsPage = () => {
  const { t } = useTranslation();

  return (
    <div style={{ padding: '1rem' }}>
      <Title order={2}>{t('job_analytics')}</Title>
    </div>
  );
};

export default JobAnalyticsPage;
